import { useFlagData } from './useFlagData';

export const useFlag = (flagId: number) => {
  const data = useFlagData(flagId);
  return data?.variantKey === 'on';
};
